import { ShieldCheck, FileCheck2 } from "lucide-react";
import { CONTENT_SOURCES } from "@/lib/content-sources";

export function ContentSourcesSection() {
  return (
    <section id="fuentes" className="border-y border-border bg-neutral-950 py-20 text-white lg:py-28">
      <div className="container mx-auto grid gap-12 px-4 lg:grid-cols-[0.85fr_1.15fr] lg:items-center">
        <div>
          <p className="text-sm font-bold uppercase text-emerald-400">Fuentes identificadas</p>
          <h2 className="mt-3 text-3xl font-bold sm:text-4xl lg:text-5xl">Un mismo tema puede tener más de una mirada</h2>
          <p className="mt-5 text-lg leading-relaxed text-neutral-300">
            Consolidamos los materiales por tema clínico y conservamos la fuente de origen. Puedes estudiar el conjunto o aislar la referencia que te interesa.
          </p>
          <div className="mt-7 flex items-start gap-3 border-l-2 border-emerald-400 pl-4 text-sm text-neutral-300">
            <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-emerald-400" />
            <p>Contenido organizado por fuente, vigencia y contexto clínico para ofrecerte un repaso claro y trazable.</p>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
          {CONTENT_SOURCES.map((source) => (
            <div key={source.id} className="min-h-24 border border-neutral-700 bg-neutral-900 p-4">
              <FileCheck2 className="h-5 w-5 text-emerald-400" />
              <p className="mt-4 text-sm font-semibold leading-snug">{source.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
